/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { getMutualManagement } from "../../../actions";
import Scrollbars from "react-custom-scrollbars";
import moment from "moment";
import { connect } from "react-redux";
import Statistics from "../../Statistics";

const headerElements = [
  { name: "Date", query: { filter: "Date", options: [] } },
  { name: "Time", query: { filter: "Time", options: [] } },
  { name: "Invited By", query: { filter: "InvitedBy", options: [] } },
  { name: "Role", query: { filter: "Role", options: [] } },
  { name: "Invited To", query: { filter: "InvitedTo", options: [] } },
  { name: "Status", query: { filter: "Status", options: [] } },
];

const Mutual = ({ getMutualManagement, invitations, period }) => {
  const [curPage, setCurPage] = useState(2);
  const tableRef = useRef();
  const [innerLoading, setInnerLoading] = useState(false);

  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 0;
    const t = (Math.round(scrollTop) + pad) / (scrollHeight - clientHeight);
    if (t >= 0.99 && invitations?.totalPages >= curPage && !innerLoading) {
      setInnerLoading(true);
      getMutualManagement({
        page: curPage,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
        onSuccess: (res) => setInnerLoading(false),
      });
      setCurPage(curPage + 1);
    }
  };

  useEffect(() => {
    getMutualManagement({ page: 1, limit: 20 });
  }, []);

  useEffect(() => {
    if (period?.startDate !== "" && period?.startDate !== null) {
      getMutualManagement({
        page: 1,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
      });
      setCurPage(2);
    }
  }, [period]);

  return (
    <Scrollbars
      style={{ height: "100%", width: "100%" }}
      onUpdate={handleUpdate}
      ref={tableRef}
      id={"scrollbar"}
    >
      <div className="table-header" style={{ width: "100%" }}>
        {headerElements?.map((header, i) => (
          <div className="header-cont" key={i} style={{ width: "16.67%" }}>
            <div className="header">{header.name}</div>
          </div>
        ))}
      </div>
      {invitations?.docs?.map((invitation, i) => (
        <div className="table-body-row" key={i} style={{ width: "100%" }}>
          <div className="row-data" style={{ width: "16.67%" }}>
            {invitation?.createdAt
              ? moment(invitation?.createdAt).format("DD.MM.YYYY")
              : "---"}
          </div>
          <div className="row-data" style={{ width: "16.67%" }}>
            {invitation?.createdAt ? moment(invitation?.createdAt).format("HH:mm") : "---"}
          </div>
          <div className="row-data" style={{ width: "16.67%" }}>
            {invitation?.createdBy?.fullName || "---"}
          </div>
          <div className="row-data" style={{ width: "16.67%" }}>
            {invitation?.role || "---"}
          </div>
          <div className="row-data" style={{ width: "16.67%" }}>
            {invitation?.invitedUser?.fullName || "---"}
          </div>
          <div className="row-data" style={{ width: "16.67%" }}>
            <span className={`status ${invitation?.status}`}>
              {invitation?.status || "Pending"}
            </span>
          </div>
        </div>
      ))}
      {innerLoading && (
        <div className="inner-loader-container">
          <Statistics.LoaderInline center />
        </div>
      )}
    </Scrollbars>
  );
};

const mapStateToProps = (state) => ({
  invitations: state.app.invitations,
});

const mapDispatchToProps = (dispatch) => ({
  getMutualManagement: (payload) => dispatch(getMutualManagement(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Mutual);
